import React, { useRef } from 'react';
import { useReactToPrint } from 'react-to-print';

import OrderComplete from './OrderComplete';

const OrderCompleteWrapper = props => {
  const contentRef = useRef(null);
  const handlePrint = useReactToPrint({
    contentRef,
  });
  return (
    <OrderComplete {...props} printRef={contentRef} handlePrint={handlePrint} />
  );
};

export default OrderCompleteWrapper;
